import about from "../img/about.jpg";

const ImageSection = () => {
  return (
    <div className="ImageSection">
      <div className="img">
        <img src={about} alt="" />
      </div>
      <div className="about-info">
        <h4>
          I am<span> Charles </span>
        </h4>
        <p className="about-text">I graduated from Department of Information Engineering, Feng Chia University</p>
        <div className="about-details">
          <div className="left-section">
            <p>Full Name</p>
            <p>Age</p>
            <p>Nationality</p>
            <p>Languages</p>
            <p>Address</p>
            <p>Countries</p>
          </div>
          <div className="right-section">
            <p>: Sin Chiin Yiew</p>
            <p>: 28</p>
            <p>: Malaysia</p>
            <p>: Chinese, English, Malay</p>
            <p>: ( Coming Soon )</p>
            <p>: Malaysia, Taiwan</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSection;
